// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a19a20aa","455":"86091cec"}[chunkId] + ".chunk.js";
};